export function getCheckValidProductPrompt(productDescription: string) {
  return `
Analyze the following message and determine if it describes a valid product. Respond with 'true' if the message contains a clear product description. Otherwise, respond with 'false' and provide a brief explanation.

<MESSAGE>
${productDescription}
</MESSAGE>
`;
}

export interface IsValidProductResponse {
  isValidProduct: boolean;
  explanation: string;
}

export function getCheckValidProductFunctions() {
  return [
    {
      name: 'determine_valid_product_description',
      description: 'Analyze the message and determine if it is a valid product description.',
      parameters: {
        type: 'object',
        properties: {
          isValidProduct: {
            type: 'boolean',
            description: 'True if the message contains a clear product description, false otherwise.',
          },
          explanation: {
            type: 'string',
            description: 'A brief explanation for the decision, especially if the product is not valid.',
          },
        },
        required: ['isValidProduct', 'explanation'],
      },
    },
  ];
}
